<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFirstAid } from '@fortawesome/free-solid-svg-icons';

import config from '@/config/config';

library.add( faFirstAid );

export default {
  name: 'Course_B_Sidebar',
  computed: {
    ...mapState(config.app, [
      'course',
      'currentCourse',
    ]),
    cover() {
      return get(this, 'course.cover.url', null);
    },
    title() {
      return get(this, 'course.title', '');
    },
    content() {
      return get(this, 'course.content', '');
    },
  },
  methods: mapMutations(config.app, [
    'setCurrentCourse',
  ]),
};
</script>
<style lang="scss">
    @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
    #course-b-sidebar {
        background: white;
        box-shadow: 1.5px 2.6px 10px 0 rgba(119, 119, 119, .75);

        .title {
            color: #d3be9f;
            font-weight: bold;
        }

        figure {
            img {
                border-radius: .25em .25em 0 0;
            }
        }

        ul {
            li {
                padding: .75em 0;
                display: flex;
                &:before {
                    font-family: FontAwesome;
                    content: '\f058';
                    color: #85d5d6;
                    margin-right: .5em;
                }
                &:first-child {
                    background-color: transparent;
                }
            }
        }
    }
</style>
<template>
    <div id="course-b-sidebar" class="rounded">
        <figure v-if="cover">
            <img :src="cover" alt="course logo" class="img-fluid" />
        </figure>

        <div class="p-3 pl-5 pr-5">
            <h5 class="mb-4 title">{{ title }}</h5>

            <div v-html="content" class="mt-5" />
<!--            <h6 class="font-weight-bold">Some other info</h6>-->
<!--            <ul>-->
<!--                <li>-->
<!--                    <a @click="setCurrentCourse(flow.start)" :class="{active: flow.start === currentCourse}">-->
<!--                        Informacje o kursie-->
<!--                    </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <a @click="setCurrentCourse(flow.lecture)" :class="{active: flow.start !== currentCourse}">-->
<!--                        Zawartość kursu-->
<!--                    </a>-->
<!--                </li>-->
<!--            </ul>-->
        </div>
    </div>
</template>
